// Version : 0.0.1
// Author : VIGNESH
// LastEdit : VIGNESH
// Last ADD : REMOVED UNWANTED REDUX AND ADDED COMMENTS
// MODFIED DATA : 07-12-2025

import { takeLatest, put, all, call } from 'redux-saga/effects';
import CreditBureauReportActionTypes from './credit-bureau-report.types';
import { creditBureauReportListGet } from './credit-bureau-report.service';
import {
	getCreditBureauReportDetailsSuccess,
	getCreditBureauReportDetailsFailure,
	getCreditBureauReportDetailsResponseChanged,
} from './credit-bureau-report.action';
import { encryptData } from '../../_common/enode-decode';
import AlertManager from '../../../utils/alertManager';

/** ***************** FETCH CREDIT BUREAU REPORT START *********************** */
export function* getCreditBureauReportList({ payload }: any) {
	try {
		const {
			companyID,
			branchID,
			centerID,
			databaseName,
			fromDate,
			toDate,
			tillDate,
			dateFilterType,
			reportType,
			userLevel,
			userID,
			userRole,
			limit,
		} = payload;

		const key = 'CreditCheckDetailsReportKey';
		const jsonData = {
			CompanyID: companyID,
			BranchID: branchID,
			CenterID: centerID,
			DatabaseName: databaseName,
			FromDate: fromDate,
			ToDate: toDate,
			TillDate: tillDate,
			DateFilterType: dateFilterType,
			ReportType: reportType,
			UserLevel: userLevel,
			UserID: userID,
			UserRole: userRole,
			Limit: limit,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(creditBureauReportListGet, encodeData);

		if (responseData.data.statusCode === '401') {
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getCreditBureauReportDetailsFailure(responseData.data));
		} else {
			yield put(getCreditBureauReportDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getCreditBureauReportDetailsFailure(error));
	}
}

export function* resetGetCreditBureauReportListResponse() {
	yield put(getCreditBureauReportDetailsResponseChanged());
}

export function* onGetCreditBureauReportListDetails() {
	yield takeLatest(
		CreditBureauReportActionTypes.GET_CREDIT_BUREAU_REPORT_LIST_START,
		getCreditBureauReportList,
	);
}

export function* onGetCreditBureauReportListResponseReset() {
	yield takeLatest(
		CreditBureauReportActionTypes.GET_CREDIT_BUREAU_REPORT_LIST_RESPONSE_RESET,
		resetGetCreditBureauReportListResponse,
	);
}
/** ***************** FETCH CREDIT BUREAU REPORT END *********************** */

export function* reportCreditBureauSaga() {
	yield all([
		call(onGetCreditBureauReportListDetails),
		call(onGetCreditBureauReportListResponseReset),
	]);
}
